import { FormSection } from 'Components';
import { FormSectionWrapper } from 'Components/FormSectionWrapper';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Title } from './Title';
import { OtherDocuments } from './OtherDocuments';

export const SixthSectionNew = () => {
  return (
    <FormSectionWrapper>
      <FormSection
        grouped
        id={Dictionary[DICTIONARY.CASE_DETAILS].sixthSectionTitle}
      >
        <Title />
        <OtherDocuments />
      </FormSection>
    </FormSectionWrapper>
  );
};
